
import { defineComponent, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import KTAside from "@/layout/aside/Aside.vue";
import KTAsideECP from "@/layout/aside/AsideECP.vue";
import KTAsideEDP from "@/layout/aside/AsideEDP.vue";
import KTAsideBIBO from "@/layout/aside/AsideBIBO.vue";


import KTAsideIGlow from "@/layout/aside/AsideIGLOW.vue";

import KTAsideECC from "@/layout/aside/AsideECC.vue";

import KTAsidePCP from "@/layout/aside/AsidePCP.vue";


import KTHeader from "@/layout/header/Header.vue";
import KTFooter from "@/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/LayoutService";
import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import KTScrollTop from "@/layout/extras/ScrollTop.vue";
import KTUserMenu from "@/layout/header/partials/ActivityDrawer.vue";
import KTLoader from "@/components/Loader.vue";
import KTCreateApp from "@/components/modals/wizards/CreateAppModal.vue";
import KTExplore from "@/layout/extras/Explore.vue";
import KTDrawerMessenger from "@/layout/extras/DrawerMessenger.vue";
import { Actions } from "@/store/enums/StoreEnums";
import { MenuComponent } from "@/assets/ts/components/index";
import { removeModalBackdrop } from "@/core/helpers/dom";


import ECShopAdvisory from "@/views/ECShopAdvisory.vue";
import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";


import {
  toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo
} from "@/core/helpers/config";
import { isDocPage } from "@/core/helpers/documentation";

export default defineComponent({
  name: "Layout",
  components: {
    KTAside,
    KTAsideECP,
    KTAsideEDP,
    KTAsideBIBO,
    KTAsideIGlow,
    KTAsideECC,
    KTAsidePCP,
    KTHeader,
    KTFooter,
    KTToolbar,
    KTScrollTop,
    KTCreateApp,
    KTUserMenu,
    KTExplore,
    KTDrawerMessenger,
    KTLoader,
    
    ECShopAdvisory,
    CompanyPolicy
  }, 
  
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const planType  = computed(() => { 
      let pt = localStorage.getItem('pt'); 
      return pt;
    });

    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });

    onMounted(() => {
      // // check if current user is authenticated
      if (store.getters.isAuthenticated) {
        router.push({ name: "sign-in" });
      }

      // Simulate the delay page loading
      setTimeout(() => {
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }, 500);
    });

    watch(
      () => route.path,
      () => {
        MenuComponent.hideDropdowns(undefined);

        // // check if current user is authenticated
        if (store.getters.isAuthenticated) {
          router.push({ name: "sign-in" });
        }

        removeModalBackdrop();
      }
    );

    return {
      toolbarDisplay,
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      pageTitle,
      planType,
      breadcrumbs,
      isDocPage,
      themeLightLogo,
      themeDarkLogo
    };
  }
});
